// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".precise-price-app .precise-price--3OnLx{font-family:Avenir,Helvetica,Arial,sans-serif;font-size:var(--font-size);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;height:100%;display:flex;flex-flow:column}", ""]);
// Exports
exports.locals = {
	"precisePrice": "precise-price--3OnLx"
};
module.exports = exports;
